import request from '@/utils/request'

export function getAuthCodeListByBook (data) {
  return request({
    url: `/platform/authCode/list?pageIndex=${data.pageIndex}&pageSize=${data.pageSize}&bookId=${data.bookId}`,
    method: 'get'
  })
}

export function getAuthCodeGenerate (data) {
  return request({
    url: `/platform/authCode/generate?bookId=${data.bookId}&count=${data.count}`,
    method: 'post'
  })
}

export function delAuthCode (id) {
  return request({
    url: `/platform/authCode/${id}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/authCode.js